import styled from "styled-components";

export const StyledCloseIconWrapper = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;
    z-index: 10;
`;
